module.exports = __webpack_public_path__ + "img/3.df8406b9.jpg";